import { PackageSubLOBProps } from "components/flexComponents/WizardPackagePWA/typings";
import * as React from "react";
import { Location } from "src/components/shared/Location/Location";
import { Dates } from "src/components/shared/Dates/Dates";
import { observer } from "mobx-react";
import { UitkLayoutConditionalGridSpan } from "uitk-react-layout-grid";

export const FlightCar = observer((props: PackageSubLOBProps) => {
  const locationColSpan: UitkLayoutConditionalGridSpan = { small: 2, medium: 12, large: 8 };
  const datesColSpan: UitkLayoutConditionalGridSpan = { small: 2, medium: 12, large: 4 };
  const { isFlightCarFormValid, updateInvalidFormsState } = props.packageWizardState;

  if (isFlightCarFormValid) {
    updateInvalidFormsState();
  }

  return (
    <>
      <Location
        setInputsRefs={props.setInputsRefs}
        originField={true}
        destinationField={true}
        lobState={props.packageWizardState}
        colSpan={locationColSpan}
        showSwapLocationsControl={true}
        globalConfig={props.globalConfig}
      />
      <Dates lobState={props.packageWizardState} colSpan={datesColSpan} setInputsRefs={props.setInputsRefs} />
    </>
  );
});
